import type { DestinationId } from './types'

export interface DestinationDef {
  id: DestinationId
  name: string
  description: string
  icon: string
  accent: string
}

export const DESTINATIONS: DestinationDef[] = [
  {
    id: 'salesforce',
    name: 'Salesforce',
    description: 'Create lead records in your CRM',
    icon: 'https://cdn.magicpatterns.com/patterns/generated-images/207a5d77-9e73-4119-b10c-7a6c3940bd7a.jpg',
    accent: 'salesforce',
  },
  {
    id: 'bonzo',
    name: 'Bonzo',
    description: 'Enroll prospects into a nurture campaign',
    icon: 'https://cdn.magicpatterns.com/patterns/generated-images/6964bab2-47bb-46ad-b5f5-cb5dece63d63.jpg',
    accent: 'orange',
  },
  {
    id: 'five9',
    name: 'Five9',
    description: 'Push records to a dialer calling list',
    icon: 'https://cdn.magicpatterns.com/patterns/generated-images/acca6161-6804-4a0a-ae25-bd0337cb132f.jpg',
    accent: 'teal',
  },
]
